import { render } from "./EmployeeDir.vue?vue&type=template&id=188f3da4&scoped=true&ts=true"
import script from "./EmployeeDir.vue?vue&type=script&lang=ts"
export * from "./EmployeeDir.vue?vue&type=script&lang=ts"

import "./EmployeeDir.vue?vue&type=style&index=0&id=188f3da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188f3da4"]])

export default __exports__